<template>
  <div class="allbox">
    <div style="margin-bottom:20px;">
      <div class="condition">
        <el-input
          v-model="query.user_id"
          class="inptw"
          placeholder="主账号id"
        />
        <el-input
          v-model="query.sub_uc_id"
          class="inptw"
          placeholder="子账号id"
        />
        <el-input
          v-model="query.adgroupFeedId"
          class="inptw"
          placeholder="推广单元id"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
      </div>
    </div>
    <el-table
      :data="baidudataList"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="adgroupFeedId"
        label="推广单元ID"
        width="120px"
      />
      <el-table-column
        prop="adgroupFeedName"
        label="推广单元名称"
        width="180px"
      />
      <el-table-column
        prop="atpFeedId"
        label="定向包ID"
        width="80px"
      />
      <el-table-column
        prop="atpName"
        label="定向包名称"
        width="80px"
      />
      <el-table-column
        prop="audience"
        label="定向设置"
        width="80px"
      />
      <el-table-column
        label="oCPC信息"
        width="150px"
      >
        <template slot-scope="scope">
          <el-button style="margin-left: 16px;" type="text" @click="openoCPC(scope.row.ocpc)">查看oCPC信息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="bid"
        label="出价"
        width="80px"
      />
      <el-table-column
        prop="bidSourceText"
        label="出价来源"
        width="120px"
      />
      <el-table-column
        prop="bidtypeText"
        label="优化目标和付费模式"
        width="160px"
      />
      <el-table-column
        prop="campaignFeedId"
        label="推广计划ID"
        width="150px"
      />
      <el-table-column
        prop="deliveryTypeText"
        label="投放场景"
        width="150px"
      />
      <el-table-column
        prop="ftypeSelectionText"
        label="流量来源"
        width="150px"
      />
      <el-table-column
        prop="id"
        label="id"
        width="80px"
      />
      <el-table-column
        prop="pauseText"
        label="暂停/启用推广单元"
        width="150px"
      />
      <el-table-column
        prop="productSetId"
        label="商品组id"
        width="80px"
      />
      <el-table-column
        prop="sub_uc_id"
        label="子账号userid"
        width="150px"
      />
      <el-table-column
        prop="unefficientAdgroupText"
        label="低效单元标识"
        width="150px"
      />
      <el-table-column
        prop="unitOcpxStatusText"
        label="单元学习状态"
        width="150px"
      />
      <el-table-column
        prop="statusText"
        label="推广单元状态"
        width="150px"
      />
      <el-table-column
        prop="url"
        label="落地页"
        width="350px"
      />
      <el-table-column
        prop="urlTypeText"
        label="落地页类型"
        width="150px"
      />
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        width="150px"
      />
    </el-table>
    <el-drawer
      title="详细信息"
      :visible.sync="isDialogVisible"
      direction="rtl"
      size="50%"
    >
      <ocpc-info-table ref="ocpcInfo" :ocpc_info="ocpc_info" />
    </el-drawer>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>

import { getBaiduADAdgroupFeedList } from '@/api/baiduAD'
import PaginationRight from '@/components/PaginationRight/index.vue'
import OcpcInfoTable from '@/views/baiduAD/components/ocpcInfoTable.vue'

export default {
  components: { OcpcInfoTable, PaginationRight },
  data() {
    return {
      baidudataList: [],
      total: 50,
      query: {
        adgroupFeedId: '',
        sub_uc_id: '',
        user_id: '',
        page: 1,
        page_size: 10
      },
      isDialogVisible: false,
      ocpc_info: null
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADAdgroupFeedList(this.query).then(res => {
        this.baidudataList = res.data.list
        this.total = res.data.total
      })
    },
    search() {
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    openoCPC(row) {
      this.ocpc_info = row
      this.isDialogVisible = true // 显示抽屉
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.tag_box{
  margin: 0 10px 10px 0px;
}
.inptw {
  width: 250px;
}
.condition >* {
  margin-right: 10px;
}
</style>
